import React from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'reactstrap';

import styles from './ProgressBar.module.scss';

const propTypes = {

	/**
	 * The progress value to display.
	 */
	progress: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),

};

const defaultProps = {
	progress: 0
};

const ProgressBar = (props) => {

	const { progress, ...restProps } = props;


	if (!Array.isArray(progress)) {
		return (
			<Progress
				{...restProps}
				color="primary"
				value={progress} />
		);
	}

	// Support progress bars with two values
	// i.e. [50, 60] or [40, 80]

	const bars = progress;
	const colors = ['primary', 'available-content'];

	return (
		<Progress multi>
			{bars.map((value, index) =>
				(<Progress
					{...restProps}
					// eslint-disable-next-line react/no-array-index-key
					key={index}
					value={value}
					color={colors[index]}
					className={`${restProps.className || ''} ${colors[index] === 'available-content' ? styles[`bg-${colors[index]}`] : ''}`.trim()}
					bar />)
			)}
		</Progress>
	);

};

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;

export default ProgressBar;
